import { render } from "./MockGraphIcon.vue?vue&type=template&id=0f24e4a8&scoped=true"
import script from "./MockGraphIcon.vue?vue&type=script&lang=js"
export * from "./MockGraphIcon.vue?vue&type=script&lang=js"

import "./MockGraphIcon.vue?vue&type=style&index=0&id=0f24e4a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f24e4a8"

export default script